import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Header from "../../components/Header/header";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import jwtDecode from "jwt-decode";
import {
  newCheckout,
  getUserpaymentData,
  confirmPaymentMethod,
  createPaymentIntent,
} from "../../utils/actions/allactions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  useStripe,
  useElements,
  Elements,
} from "@stripe/react-stripe-js";
import { currencyFormatter } from "../../utils/helper";
import moment from "moment";
import { sendOrderCreationMailToAdmin } from "../../utils/actions/userActions";
import { DeleteIcon, DownloadIcon } from "../../components/Icons";
import { CrossIcon } from "../../components/GlobalProjectNameComponent";
import { sendPaymentErrorDetailsToAdmin } from "../../api/customer/salesOrder/commonSalesOrderApi";
import useDocumentTitle from "../../utils/useDocumentTitle";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const Payments = () => {
  let navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = React.useState(false);
  let [part, setPart] = useState({});
  let [bill, setBill] = useState({});
  let [paymentIntent, setPaymentIntent] = useState("");
  let [loading, setLoading] = useState(false);
  let [addNewCard, setAddNewCard] = useState(false);
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [placingInProcess, setPlacingInProcess] = useState(false);
  let token = localStorage.getItem("Token");
  let [ordr, setOrdr] = useState({
    ordrNbr: "",
    checkbx: false,
    file: "",
  });
  let [error, setError] = useState({
    ordrNbr: "",
    checkbx: "",
    poFile: "",
  });

  useEffect(() => {
    if (ordr.checkbx) {
      setOrdr((pre) => {
        return { ...pre, ordrNbr: '', file: "" }
      })
    }

  }, [ordr.checkbx]);

  console.log("Item :", ordr);

  const [showRedirectModal, setShowRedirectModal] = useState(false);

  const RedirectComponent = () => {
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate("/my-orders");
      }, countdown * 1000);

      return () => clearTimeout(timer);
    }, [countdown, navigate]);

    useEffect(() => {
      if (countdown > 0) {
        const countdownTimer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(countdownTimer);
      }
    }, [countdown]);

    return <div>Redirecting in {countdown} seconds...</div>;
  };

  const loggedInUser = localStorage.getItem("Token");
  if (loggedInUser) {
    var userfirstName = jwtDecode(localStorage.getItem("Token"))?.firstName;
    var userlastName = jwtDecode(localStorage.getItem("Token"))?.lastName;
  }
  let params = useParams();
  let location = useLocation();

  let _id = params._id;
  let user_id = localStorage.getItem("_id");

  const handlePaymentIntent = async (paymentMethodId) => {
    try {
      setPlacingInProcess(true);
      await confirmPaymentMethod(
        { paymentIntentId: paymentIntent.id, paymentMethodId },
        token
      );

      setShowRedirectModal(true)
    } catch (err) {
      console.log("Error", err)
      toast.error(err.message);
    }
  };

  const fetchPaymentMethod = async (bill) => {
    setPaymentLoading(true);
    const { data } = await getUserpaymentData(token);
    if (data?.paymentMethods?.length) setPaymentMethods(data.paymentMethods);
    let formData = {
      shippingAddress: bill.shippingAddress,
      billingAddress: bill.billingAddress,
      tax: bill.tax,
      subTotal: bill.subTotal,
      quoteId: bill.quoteId,
      purchaseNumber: ordr.ordrNbr,
      orderNumberLater: ordr.checkbx,
      shipping: bill.shipping,
      certifications: bill.certifications,
      file: null,
      purchaseNumber: "",
      orderNumberLater: false,
      selectedShipMethod: bill.selectedShipMethod,
      system:"MAKE_PORTAL"
    };
    const { data: paymentIntentData } = await createPaymentIntent(
      {
        amount: parseInt(
          (
            ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) +
            (bill.tax ? ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) / bill.tax : 0))
          * 100
        ),
        orderDetail: formData,
      },
      token
    );

    setPaymentIntent(paymentIntentData.intent);
    setPaymentLoading(false);
  };

  const StripeWrapper = () => {
    const stripe = useStripe();
    const elements = useElements();

    const onFinish = async () => {
      if (elements == null) return;

      try {
        const response = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: "http://localhost:3000/",
          },
          redirect: "if_required",
        });

        console.log("response", response);
        setShowPaymentModal(false);
        setAddNewCard(false);

        if (response.error) {
          console.log("Payment error:", response.error);

          let errorMessage = "Payment failed. Please try again.";

          switch (response.error.code) {
            case "payment_intent_authentication_failure":
              errorMessage = "Authentication failed! Please check your banking app or use another payment method.";
              break;
            case "card_declined":
              errorMessage = "Your card was declined. Please use another card.";
              break;
            case "expired_card":
              errorMessage = "Your card has expired. Please use a valid card.";
              break;
            case "incorrect_cvc":
              errorMessage = "Incorrect CVC code. Please check and try again.";
              break;
            case "insufficient_funds":
              errorMessage = "Insufficient funds. Please use another payment method.";
              break;
            case "processing_error":
              errorMessage = "There was a processing error. Please try again later.";
              break;
            case "incorrect_number":
              errorMessage = "The card number is incorrect. Please check and enter again.";
              break;
            default:
              errorMessage = response.error.message || "An unexpected error occurred. Please try again.";
          }

          toast.error(errorMessage);

          try {
            console.log("Attempting to send email notification to admin");

            if (response.error.code !== "payment_intent_authentication_failure") {
              return;
            }
          } catch (err) {
            console.log("Failed to send email notification.");
          }
        } else {
          setShowRedirectModal(true);
        }
      } catch (err) {
        console.log("Payment process failed:", err);
        toast.error(`Unexpected Error: ${err.message || "Something went wrong. Please try again."}`);
      }


    };
    return (
      <div
        className="checkout-container"
        style={{ display: "flex", flexDirection: "column", gap: 24 }}
      >
        <div className="payment-method">
          <div className="payment-details">
            <PaymentElement />
          </div>
        </div>

        <button
          loading={btnLoading}
          onClick={onFinish}
          className="primary-btn"
        >
          {!placingInProcess
            ? `Pay ${currencyFormatter(
              parseInt(
                (
                  ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) +
                  (bill.tax ? ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) / bill.tax : 0))
              )
            )}`
            : `Placing Order...`}
        </button>
      </div>
    );
  };
  const handleRedirect = () => {
    if (selectedPaymentMethod == 'card') {
      setShowRedirectModal(true);
    }
    else {
      navigate(`/my-orders`);
    }
  }





  let handleSubmit = async () => {
    console.log("Sending Bill :", bill);
    try {
      if (ordr.checkbx == false) {
        if (ordr.ordrNbr == "" || ordr?.file == "") {
          setError((val) => ({
            ...val,
            ordrNbr: "Please upload PO file and enter PO number to proceed !",
          }));
        } else {
          

          setLoading(true);
          let token = localStorage.getItem("Token");
          let formData = new FormData();
          formData.append("shippingAddress", bill.shippingAddress);
          formData.append("billingAddress", bill.billingAddress);
          formData.append("tax", bill.tax);
          formData.append("subTotal", bill.subTotal);
          formData.append("shipping", bill.shipping);
          formData.append("certifications", bill.certifications);
          formData.append("quoteId", bill.quoteId);
          formData.append("file", ordr.file);
          formData.append("purchaseNumber", ordr.ordrNbr);
          formData.append("orderNumberLater", ordr.checkbx);
          formData.append("selectedShipMethod", bill.selectedShipMethod);

          newCheckout(formData, token)
            .then((res) => {
              if (res.data.status == false) {
                setLoading(false);
                navigate("/get-instant-quote/checkout/" + _id, {
                  state: {
                    billing: location.state.billing,
                    part: location.state.part,
                  },
                });
                toast.error("Failed to place order! Please try again later.");
              } else {
                //admin order creation email here
                let data = {
                  orderId: res.data.data.RefId,
                };
                sendOrderCreationMailToAdmin(token, data)
                  .then((resData) => {
                    setLoading(false);
                    handleRedirect();
                  })
                  .catch((err) => {
                    setLoading(false);
                    handleRedirect();

                    console.log("email not sent error", err);
                  });
              }
            })
            .catch((err) => {
              console.log(
                "error in payments 278 on" +
                moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
                err
              );
              setLoading(false);
              toast.error("Something went wrong");
            });
        }
      } else {
        setError((val) => ({
          ...val,
          ordrNbr: "",
        }));
        setLoading(true);
        let token = localStorage.getItem("Token");

        let formData = new FormData();
        formData.append("shippingAddress", bill.shippingAddress);
        formData.append("billingAddress", bill.billingAddress);
        formData.append("tax", bill.tax);
        formData.append("subTotal", bill.subTotal);
        formData.append("shipping", bill.shipping);
        formData.append("certifications", bill.certifications);
        formData.append("quoteId", bill.quoteId);
        formData.append("file", ordr.file);
        formData.append("purchaseNumber", ordr.ordrNbr);
        formData.append("orderNumberLater", ordr.checkbx);
        formData.append("selectedShipMethod", bill.selectedShipMethod);

        newCheckout(formData, token)
          .then((res) => {
            setLoading(false);
            if (res?.response?.data?.data?.message) {
              toast.error(res.response.data.data.message);
            } else if (res?.data?.status == true) {
              //admin order creation email here
              let data = {
                orderId: res.data.data.RefId,
              };
              sendOrderCreationMailToAdmin(token, data);
              handleRedirect();
            } else {
              navigate("/get-instant-quote/checkout/" + _id, {
                state: {
                  billing: location.state.billing,
                  part: location.state.part,
                },
              });
              toast.error("Failed to place order! Please try again later.");
            }
          })
          .catch((err) => {
            setLoading(false);
            return err;
          });
      }
    } catch (error) {
      console.log(
        "error in payments 349 on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        error
      );
      return error;
    }
  };

  useEffect(() => {
    async function fetchData() {
      let token = localStorage.getItem("Token");
      if (token) {
        let decode = jwtDecode(token);
        if (!decode) {
          navigate("/login");
        } else if (decode.userType == "admin") {
          navigate("/admin");
        } else if (decode.userType == "user") {
          if (location.state && location.state !== null) {
            setPart(location.state.part);
            setBill(location.state.billing);
            // paymentIntent?.client_secret && !showPaymentModal && setShowPaymentModal(true)
          } else {
            navigate("/saved-quote");
            toast.error("Data not found!");
          }
        } else {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    }
    fetchData();
  }, []);

  console.log("Bill :", bill);
  console.log(paymentMethods)

  useDocumentTitle('Payment method');

  return (
    <div className="content-wrapper payments-screen">
      <Header />
      <Modal
        size="lg"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRedirectModal}
        onHide={() => {
          navigate(`/my-orders`);
          setShowRedirectModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="sub-header"
          >
            Order created successfully.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <p className="text">
                A sales order confirmation will be sent once the payment is completed or a copy of the purchase order is received.
              </p>
              <RedirectComponent />
            </div>
            <br />
          </div>
          <div style={{ color: "#8b8b8b" }}></div>
        </Modal.Body>
      </Modal>

      <div className="intro-bar">
        <div className="int-left">
          <p className="info-text">Start Production - Select Payment Method</p>
          <p className="sub-header">
            Quotation Reference ID: #
            {part && part.RefId ? part.RefId : "Loading..."}{" "}
          </p>
        </div>
        <div className="int-right">
          <p className="sub-header">
            {bill.subTotal
              ? currencyFormatter(
                ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) +
                (bill.tax ? ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) / bill.tax : 0)
              )

              : "Loading..."}
          </p>
        </div>
      </div>

      <div className="dashboard-holder">
        <div className="sm-container">
          <div className="common-bx">
            <div className="payment-option">
              <div className="pay-heading">
                <div className="rd-box">
                  <input
                    type="radio"
                    id="test1"
                    checked={selectedPaymentMethod == 'card'}
                    name="radio-group"
                    onClick={() => setSelectedPaymentMethod("card")}
                  />
                  <label
                    htmlFor="test1"
                    className="text w-100"
                    onClick={async () => {
                      await fetchPaymentMethod(location.state.billing);
                      setSelectedPaymentMethod("card");
                    }}
                  >
                    Pay Now
                  </label>
                </div>
              </div>

              {selectedPaymentMethod == "card" && (
                <div>
                  <br />
                  <br />
                  <div className="addresses">
                    {paymentLoading ?
                      <div className="addressTitle text-center">Loading...</div> :
                      (paymentMethods?.length > 0) ?
                        <div className="addressTitle text-center">My Cards</div> :
                        (paymentMethods?.length === 0) ?
                          <div className="addressTitle text-center">Add atleast one card to pay</div> : null
                    }
                    <div className="cardContainer">
                      {!paymentLoading && (
                        paymentMethods?.map((cardDetails, index) => {
                          const { card, id } = cardDetails;
                          const { exp_month, exp_year, last4, brand } = card;
                          // console.log("card", card)
                          return (
                            <div
                              key={index}
                              onClick={() => setSelectedCard(id)}
                              className="card"
                              style={{
                                boxShadow: "3px 3px 12px 10px #00000010",
                                borderRadius: 10,
                                padding: 16,
                                cursor: "pointer",
                                position: "relative",
                                borderColor:
                                  id == selectedCard ? "blue" : "white",
                              }}
                            >
                              <div
                                className="cardContainer"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "100%",
                                  margin: 0,
                                }}
                              >
                                <div
                                  className="card-no"
                                  style={{ fontSize: 20, color: "black" }}
                                >
                                  XXXX-XXXX-XXXX-{last4}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="card-exp"
                                    style={{ fontSize: 16, color: "black" }}
                                  >
                                    {exp_month} / {exp_year}
                                  </div>
                                  <div
                                    className="card-brand"
                                    style={{ fontSize: 20, color: "black" }}
                                  >
                                    {brand}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="buttons"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "50%",
                                  bottom: "50%",
                                  transform: "translate(50%, 50%)",
                                }}
                              >
                                <span style={{ color: "#00000050" }}>
                                  Select to pay
                                </span>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                  <div className="btn-div">
                    <button onClick={() => setAddNewCard(true)} className="border-btn">Add Card</button>
                    <button
                      className="primary-btn"
                      disabled={!selectedCard}
                      onClick={() =>
                        placingInProcess
                          ? null
                          : handlePaymentIntent(selectedCard)
                      }
                    >
                      {!placingInProcess
                        ? `Pay ${currencyFormatter(
                          ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) +
                          (bill.tax ? ((bill.subTotal || 0) + (bill?.shipping || 0) + (bill?.certifications || 0)) / bill.tax : 0)
                        )}`
                        : `Placing Order...`}
                    </button>
                  </div>
                  {paymentIntent?.client_secret && addNewCard && (
                    <Modal show={true} onHide={() => setAddNewCard(false)} centered>
                      <Modal.Header closeButton>
                        <Modal.Title className="sub-header">Complete Payment</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p className="text mb-4">
                          Input your payment details to checkout.
                        </p>
                        <div className="card-list">
                          <Elements
                            stripe={stripePromise}
                            options={{
                              clientSecret: paymentIntent.client_secret,
                              appearance: {
                                theme: "stripe",
                                variables: {
                                  fontWeightNormal: "500",
                                  fontSizeLg: "16px",
                                },
                              },
                            }}
                          >
                            <StripeWrapper />
                          </Elements>
                        </div>
                      </Modal.Body>
                    </Modal>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="common-bx later-box">
            <div
              className="rd-box"
              onClick={() => setSelectedPaymentMethod("later")}
            >
              <input checked={selectedPaymentMethod == 'later'} type="radio" id="test2" name="radio-group" />
              <label htmlFor="text2" className="text w-100">Pay Later</label>
            </div>

            {selectedPaymentMethod == "later" && (
              <div className="pay-later-doc">
                <div className="pl-form">
                  <div>
                    <Row>
                      <Col md={3}>
                        <div className="mb-3">
                          <label>Purchase Order Number</label>
                          <Form.Control
                            type="text"
                            placeholder="Enter"
                            disabled={ordr.checkbx}
                            value={ordr.ordrNbr}
                            onChange={(e) => {
                              setOrdr((val) => ({
                                ...val,
                                ordrNbr: e.target.value,
                              }));
                              setError((val) => ({ ...val, ordrNbr: "" }));
                            }}
                          />
                          <span className="error">{error.ordrNbr}</span>
                        </div>
                      </Col>
                      <Col md={9}>
                        <div className="mb-3 flex items-center gap-x-2">
                          <div>
                            <label>Document</label>
                            {!ordr.file && (
                              <div className="ul-files  ">
                                <div className="file-button">
                                  <input
                                    type="file"
                                    name="file-input"
                                    id="file-input"
                                    className="file-input__input"
                                    onChange={(e) => {
                                      setOrdr((val) => ({
                                        ...val,
                                        file: e.target.files[0],
                                      }));
                                    }}
                                  />
                                  <label htmlFor="file-input">
                                    {" "}
                                    <span>Browse</span>
                                  </label>
                                </div>
                              </div>
                            )}
                            <div className="flex justify-center  items-center gap-x-2  ">
                              {ordr.file ? (
                                <span className="text-primaryColor text-sm ">
                                  {ordr.file.name}
                                </span>
                              ) : (
                                ""
                              )}
                              {ordr.file && (
                                <div className="flex gap-x-2">
                                  <a
                                    href={URL.createObjectURL(ordr.file)}
                                    download={ordr.file.name}
                                  >
                                    <DownloadIcon />
                                  </a>
                                  <div
                                    onClick={(e) => {
                                      setOrdr((val) => ({
                                        ...val,
                                        file: "",
                                      }));
                                    }}
                                  >
                                    <DeleteIcon
                                      additionalClasses={"h-5 text-red-500"}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="apply-check">
                    <input
                      type="checkbox"
                      id="sign-check"
                      name="checkbox"
                      value="Apple"
                      onChange={() =>

                        setOrdr((val) => {
                          if (val.checkbx) {
                            return { ...val, checkbx: !val.checkbx, file: "", ordrNbr: "" }
                          }

                          return ({ ...val, checkbx: !val.checkbx })
                        })

                      }
                    />
                    <label htmlFor="sign-check">Purchase order will be sent later by email</label>
                  </div>

                  <div className="btn-div">
                    <Link
                      to={"/get-instant-quote/checkout/" + _id}
                      state={{
                        billing: location.state.billing,
                        part: location.state.part,
                      }}
                      className="border-btn"
                    >
                      Back
                    </Link>
                    <button className="primary-btn" onClick={handleSubmit}>
                      Place Order
                    </button>
                  </div>

                  {loading ? <Loading /> : ""}
                </div>

                <div></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Payments;
